import { render } from "./TranscriptEditor.vue?vue&type=template&id=1f36b5a3"
import script from "./TranscriptEditor.vue?vue&type=script&lang=js"
export * from "./TranscriptEditor.vue?vue&type=script&lang=js"

import "./TranscriptEditor.vue?vue&type=style&index=0&id=1f36b5a3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__